import React, { useState } from "react";
import styles from "../../Secure.module.scss";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useAuth } from "../../../../context/AuthContext";
import { Methods, useFetch } from "../../../../hooks/useFetch";

interface UserListingCardProps {
  created_at: string | null | undefined;
  name: string | null | undefined;
  username: string | null | undefined;
  followed: number;
  id: number | null | undefined;
  number_of_bets: number | null | undefined;
  avg_odd: number | null | undefined;
  success_rate: number | null | undefined;
}

export const UserStatisticsListing: React.FC<UserListingCardProps> = ({
  created_at,
  name,
  username,
  number_of_bets,
  avg_odd,
  success_rate,
  id,
  followed,
}) => {
  const navigate = useNavigate();
  const [follow, setFollow] = useState<boolean>(Boolean(followed));
  const { user } = useAuth();

  const { makeRequest: handleFollow } = useFetch(`/api/users/follow`, {
    method: Methods.POST,
    body: { followed_id: id },
  });

  const handleFollowUser = async () => {
    setFollow(!follow);
    await handleFollow();
  };

  return (
    <div className={`${styles.searchUsersWidget} ${styles.compact}`}>
      <img
        src={"../assets/images/profile_picture.jpg"}
        loading="lazy"
        alt={`Profile pic`}
        className={styles.searchUsersPhoto}
        onClick={() => navigate(`/users/${id}`)}
      />
      <div className={styles.searchUsersInformation}>
        <div className={styles.searchUsersInformationSince}>
          {created_at ? moment(created_at).format("MMMM YYYY") : "N/A"}
        </div>
        <div className={styles.searchUsersInformationName}>
          {name ? name : "N/A"}
        </div>
        <div className={styles.searchUsersInformationCountry}>
          {username ? username : "N/A"}
        </div>
      </div>
      <div
        className={`${styles.profileContentMyStatisticsCardInformation} ${styles.extraCardStyles}`}
      >
        <div className={styles.profileContentMyStatisticsCardInformationWidget}>
          <div className={styles.statistics_label}>No. of bets</div>
          <div className={styles.statistics_parametar}>
            {number_of_bets !== null ? number_of_bets : "N/A"}
          </div>
        </div>
        <div className={styles.profileContentMyStatisticsCardInformationWidget}>
          <div className={styles.statistics_label}>Avg. odd</div>
          <div className={styles.statistics_parametar}>
            {avg_odd !== null ? avg_odd : "N/A"}
          </div>
        </div>
        <div className={styles.profileContentMyStatisticsCardInformationWidget}>
          <div className={styles.statistics_label}>Success rate</div>
          <div className={styles.statistics_parametar}>
            {success_rate !== null ? `${success_rate}%` : "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
};
